import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

interface Availability {
  id?: number;
  dayOfWeek: number;
  startTime: string;
  endTime: string;
}

@Component({
  selector: 'app-availability-blocks',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './availability-blocks.component.html',
  styleUrls: ['./availability-blocks.component.scss']
})
export class AvailabilityBlocksComponent {
  @Input() availability: Availability[] = [];
  @Input() compact: boolean = false;
  @Input() maxBlocks: number = 0; // 0 means show all

  expanded: boolean = false;

  private dayMapping: { [key: number]: string } = {
    1: 'MO',
    2: 'TU',
    3: 'WE',
    4: 'TH',
    5: 'FR',
    6: 'SA',
    7: 'SU'
  };

  getDayName(dayOfWeek: number): string {
    return this.dayMapping[dayOfWeek] || '';
  }

  getDisplayedAvailability(): Availability[] {
    if (this.expanded || this.maxBlocks === 0) {
      return this.availability;
    }
    if (this.maxBlocks > 0 && this.availability.length > this.maxBlocks) {
      return this.availability.slice(0, this.maxBlocks);
    }
    return this.availability;
  }

  getRemainingCount(): number {
    if (this.maxBlocks > 0 && this.availability.length > this.maxBlocks && !this.expanded) {
      return this.availability.length - this.maxBlocks;
    }
    return 0;
  }

  toggleExpanded(): void {
    this.expanded = !this.expanded;
  }

  // Group availability by day for a more compact display
  getGroupedAvailability(): { day: string; slots: Availability[] }[] {
    const grouped: { [key: string]: Availability[] } = {};

    this.availability.forEach(slot => {
      const day = this.getDayName(slot.dayOfWeek);
      if (!grouped[day]) {
        grouped[day] = [];
      }
      grouped[day].push(slot);
    });

    // Convert to array and sort by day of week
    return Object.keys(grouped)
      .map(day => ({
        day,
        slots: grouped[day].sort((a, b) => a.startTime.localeCompare(b.startTime))
      }))
      .sort((a, b) => {
        const dayOrder = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
        return dayOrder.indexOf(a.day) - dayOrder.indexOf(b.day);
      });
  }
}